import { ValidationError } from './apiError';
import { isLeft } from 'fp-ts/lib/Either';
import { RawApi } from '.';
import {
  feedApiResponse,
  Feed,
} from './validators/feed';

export interface FeedAPI {
  fetchFeed: (type: string, entityTagIds: string[], pageSize: number, optionalArgs?: object, continuationToken?: string) => Promise<Feed>;
}

export class FeedApi extends RawApi implements FeedAPI {
  public async fetchFeed(
    type: string,
    entityTagIds: string[],
    pageSize: number,
    optionalArgs?: object,
    continuationToken?: string,
  ): Promise<Feed> {
    const body = {
      type,
      entityTagIds,
      pageSize,
      continuationToken,
      ...(optionalArgs ?? {}),
    };

    const response = await this.fetchScoresApi(`/feed/v5/feed`, 'post', body);
    const jsonResponse: unknown = await response.json();

    const feed = feedApiResponse.decode(jsonResponse);

    if (isLeft(feed)) {
      throw new ValidationError('API Response validation failed', 400, feed);
    }

    return feed.right;
  }
}
